import { z } from 'zod';

/**
 * Relatorio do padrinho (GS2): por afilhado, de 15 em 15 dias, menos de um
 * minuto. "Como esta?", "Em que?" (so se precisa de atencao) e uma nota
 * opcional. Os numeros da Twitch do periodo vem preenchidos. "Precisa de
 * atencao" ou "Nao consegui falar" poem o afilhado na lista do Stream Staff.
 * A nota e interna: o streamer nunca a ve.
 */

const datetimeSchema = z.string().datetime({ offset: true });

/** De quantos em quantos dias o padrinho entrega o relatorio. */
export const CHECKUP_DAYS = 15;

export const checkupStatusSchema = z.enum(['ok', 'attention', 'unreachable']);
export type CheckupStatus = z.infer<typeof checkupStatusSchema>;

export const checkupTopicSchema = z.enum([
  'technical',
  'content',
  'motivation',
  'conduct',
  'other',
]);
export type CheckupTopic = z.infer<typeof checkupTopicSchema>;

export const checkupInputSchema = z
  .object({
    status: checkupStatusSchema,
    topics: z.array(checkupTopicSchema).max(5).default([]),
    note: z
      .string()
      .trim()
      .max(2000)
      .transform((s) => (s === '' ? null : s))
      .nullable()
      .default(null),
  })
  .superRefine((v, ctx) => {
    if (v.status === 'attention' && v.topics.length === 0) {
      ctx.addIssue({ code: 'custom', path: ['topics'], message: 'escolhe pelo menos um tema' });
    }
  })
  .transform((v) => ({ ...v, topics: v.status === 'attention' ? [...new Set(v.topics)] : [] }));
export type CheckupInput = z.input<typeof checkupInputSchema>;

/** Os numeros da Twitch de um periodo, preenchidos sem perguntar. */
export const checkupPeriodSchema = z.object({
  from: datetimeSchema,
  sessions: z.number().int(),
  minutesLive: z.number().int(),
  lastStreamAt: datetimeSchema.nullable(),
});
export type CheckupPeriod = z.infer<typeof checkupPeriodSchema>;

export const checkupSchema = z.object({
  id: z.string().uuid(),
  padrinho: z.string(),
  status: checkupStatusSchema,
  topics: z.array(checkupTopicSchema),
  note: z.string().nullable(),
  period: checkupPeriodSchema,
  createdAt: datetimeSchema,
});
export type Checkup = z.infer<typeof checkupSchema>;

/** Quando e o proximo relatorio de um afilhado (na lista do padrinho). */
export const checkupDueSchema = z.object({
  lastAt: datetimeSchema.nullable(),
  lastStatus: checkupStatusSchema.nullable(),
  dueOn: datetimeSchema,
  overdue: z.boolean(),
});
export type CheckupDue = z.infer<typeof checkupDueSchema>;

/** O formulario do padrinho: o periodo por relatar e os relatorios anteriores. */
export const afilhadoCheckupsSchema = z.object({
  due: checkupDueSchema,
  period: checkupPeriodSchema,
  items: z.array(checkupSchema),
});
export type AfilhadoCheckups = z.infer<typeof afilhadoCheckupsSchema>;

/** Um afilhado na lista "Precisa de atencao" do Stream Staff. */
export const attentionItemSchema = z.object({
  streamer: z.object({
    id: z.string().uuid(),
    displayName: z.string(),
    channel: z.string(),
  }),
  checkup: checkupSchema,
});
export type AttentionItem = z.infer<typeof attentionItemSchema>;
